// frontend/src/services/communicationsApi.js
import { http } from "./http";

function buildQuery(params = {}) {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    q.set(k, String(v));
  });
  const qs = q.toString();
  return qs ? `?${qs}` : "";
}

export function commsProviderStatus(token) {
  return http(`/api/admin/comms/providers`, { token });
}

export function commsListBatches(token, params = {}) {
  return http(`/api/admin/comms/batches${buildQuery(params)}`, { token });
}

export function commsListLogs(token, params = {}) {
  return http(`/api/admin/comms/logs${buildQuery(params)}`, { token });
}

export function commsSend(token, payload = {}) {
  return http(`/api/admin/comms/send`, {
    method: "POST",
    token,
    body: payload,
  });
}

/**
 * ✅ NEW: Search recipients for AudiencePicker / Individuals
 * GET /api/admin/comms/recipients?q=&role=&status=&limit=&offset=
 */
export function commsSearchRecipients(token, params = {}) {
  return http(`/api/admin/comms/recipients${buildQuery(params)}`, { token });
}
